export default "__VITE_ASSET__70a936c0__"